/**
* this file contains the array for the left menu component
*
* Created by Tom on 28/5/17
*/

// menu icon import
import DashIcon from '../../assets/svg/dash.svg'
import MyFundIcon from '../../assets/svg/wallet.svg'
import TradingIcon from '../../assets/svg/trading.svg'
import DocumentIcon from '../../assets/svg/documents.svg'
import BillingIcon from '../../assets/svg/billing.svg'

const menuItems = [
    {
        menuIcon: DashIcon,
        menuText: 'DASHBOARD',
        isExternal: false,
        route: '/'
    },
    {
        menuIcon: MyFundIcon,
        menuText: 'MY FUND',
        isExternal: false,
        route: '/myfund'
    },
    {
        menuIcon: TradingIcon,
        menuText: 'TRADING',
        isExternal: true,
        route: 'http://www.google.com.au'
    },
    {
        menuIcon: DocumentIcon,
        menuText: 'DOCUMENTS',
        isExternal: false,
        route: '/documents'
    },
    {
        menuIcon: BillingIcon,
        menuText: 'BILLING',
        isExternal: false,
        route: '/billing'
    }
]

export default menuItems



// WEBPACK FOOTER //
// ./src/components/LeftMenu/menuItems.js